import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type InboxUnopenedCountEventSubscriptionVariables = Types.Exact<{
  scope: Types.InboxScopeInput;
}>;


export type InboxUnopenedCountEventSubscription = { __typename?: 'Subscription', inbox?: { __typename?: 'InboxUnopenedCountUpdatePayload', unopenedCount?: number | null, timestamp?: string | null } | null };


export const InboxUnopenedCountEvent = /*#__PURE__*/ gql`
    subscription InboxUnopenedCountEvent($scope: InboxScopeInput!) {
  inbox(scope: $scope) {
    ... on InboxUnopenedCountUpdatePayload {
      unopenedCount
      timestamp
    }
  }
}
    ` as unknown as DocumentNode<InboxUnopenedCountEventSubscription, InboxUnopenedCountEventSubscriptionVariables>;

          

          export const useInboxUnopenedCountEventSubscription = (options?:SubscriptionHookOptions<InboxUnopenedCountEventSubscription, InboxUnopenedCountEventSubscriptionVariables>) => useSubscription(InboxUnopenedCountEvent, options);

          

          export type InboxUnopenedCountEventSubscriptionOptions = SubscriptionHookOptions<InboxUnopenedCountEventSubscription, InboxUnopenedCountEventSubscriptionVariables>;

          

          export type InboxUnopenedCountEventSubscriptionResult = ReturnType<typeof useInboxUnopenedCountEventSubscription>;

          
